import { Environment } from 'relay-runtime';
import CartUpdateEventIdMutation from '../../../mutationsModern/Cart/CartUpdateEventIdMutation';

export type HandleShopEventProps = {
  environment: Environment;
  eventId: string;
  reassignSatelliteIfPossible?: boolean;
  callback?: () => void;
};

export function handleShopEvent({
  callback,
  eventId,
  environment,
  reassignSatelliteIfPossible = false,
}: HandleShopEventProps) {
  CartUpdateEventIdMutation.commit({
    environment,
    eventId,
    reassignSatelliteIfPossible,
    onCompleted: (response: any) => {
      if (callback) {
        callback();
      }
      console.log('response for update eventId', response);
    },
    onError: (transaction: {}) => {
      console.log('error for update event id', transaction);
    },
  });
}
